<div class="nodeInfoContainer">
  <label class="fontSemiBold">
    <a class="home_link" (click)="navigateHome()" style="cursor: pointer;">
      <span class="material-icons material-home" style="padding-right: 2px;">home</span>
      <span>Home</span>
      </a>
    Node Information</label>
  <div class="overflowYscroll nodeContInner" [ngStyle]="{'height':nodeInfoTableHeight+'px'}">
    <table class="table" id="tableFix">
      <thead>
        <tr>
          <th>Node Type</th>
          <th style="width: 250px;">Node</th>
          <th>Price (USD)</th>
          <th>Fast Throughput (GB/hr)</th>
          <th>Slow Throughput (GB/hr)</th>
          <th>SmartFile Read 4K (IOPS)</th>
          <th>SmartFile Write 4K (IOPS)</th>
          <th>SmartFile Read 1M (GB/hr/node)</th>
          <th>SmartFile Write 1M (GB/hr/node)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let nodeInfo of nodeInformation; let i = index">
          <td>{{nodeInfo[0]}}</td>
          <td>
            {{nodeInfo[1]}}
            <div class="dropdown float-right positionRelative"
              *ngIf="nodeInfo[0] === 'Cohesity Physical' && (nodeInfo[2][1] === undefined) && nodeInfo[2]">
              <div class="state dropdown-toggle  cust-dropdown dropdown-ellipsis" data-display="static"
                data-toggle="dropdown">
                {{nodeListDropdown[i] === undefined ?  objectKeys(nodeInfo[2])[0] : nodeListDropdown[i]}}
              </div>
              <span class="material-icons arrow_position">arrow_drop_down</span>
              <div class="dropdown-menu dropdown-menu-right">
                <li *ngFor="let priceObject of objectKeys(nodeInfo[2])" class="dropdown-item"
                  (click)="nodeListDropdown[i] = priceObject">{{priceObject}} </li>
              </div>
            </div>
          </td>
          <td *ngIf="nodeInfo[0] !== 'Cohesity Physical'">
            <span *ngIf="nodeInfo[2] !== 0">{{nodeInfo[2]}}</span>
            <span *ngIf="nodeInfo[2] === 0">N/A</span>
          </td>
          <td *ngIf="nodeInfo[0] === 'Cohesity Physical' && (nodeInfo[2][1] !== undefined)">{{nodeInfo[2][1]}}</td>
          <td *ngIf="nodeInfo[0] === 'Cohesity Physical' && (nodeInfo[2][1] === undefined) && nodeInfo[2]">
            <span *ngFor="let priceObject of objectKeys(nodeInfo[2])">
              <div
                *ngIf="nodeListDropdown[i] === undefined ?  (objectKeys(nodeInfo[2])[0] === priceObject) : (nodeListDropdown[i] === priceObject)">
                <span class="priceList" *ngFor="let price of objectKeys(nodeInfo[2][priceObject])">
                  <div class="border-sides d-flex">
                    <div class="border-right px-2 py-1">{{price}}</div>
                    <div class="px-2 py-1">{{nodeInfo[2][priceObject][price]}}</div>
                  </div>
                </span>
              </div>
            </span>
          </td>
          <td>{{nodeInfo[3]}}</td>
          <td>{{nodeInfo[4]}}</td>
          <td>{{nodeInfo[5]}}</td>
          <td>{{nodeInfo[6]}}</td>
          <td>{{nodeInfo[7]}}</td>
          <td>{{nodeInfo[8]}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>